import Phaser from "phaser";
import { BootScene } from "./scenes/BootScene.js";
import { OfficeScene } from "./scenes/OfficeScene.js";
import { PreloadScene } from "./scenes/PreloadScene.js";

export function createGame(parent: HTMLElement): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: "#12141c",
    pixelArt: true,
    roundPixels: true,
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: [BootScene, PreloadScene, OfficeScene],
  });
}
